var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#D7FFC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3251 5.88917C13.8573 5.88917 14.2888 5.45769 14.2888 4.92542C14.2888 4.39316 13.8573 3.96167 13.3251 3.96167C12.7928 3.96167 12.3613 4.39316 12.3613 4.92542C12.3613 5.45769 12.7928 5.88917 13.3251 5.88917Z",
    fill: "#39BB0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2526 4.54224C15.6784 4.54224 16.0237 4.197 16.0237 3.77112C16.0237 3.34524 15.6784 3 15.2526 3C14.8267 3 14.4814 3.34524 14.4814 3.77112C14.4814 4.197 14.8267 4.54224 15.2526 4.54224Z",
    fill: "#39BB0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4915 16.1561L14.4817 9.74476V7.81934H15.6384V6.47003H9.08418V7.81934H10.2409V9.74476L6.2311 16.1561C6.08409 16.4287 6 16.7403 6 17.0722C6 18.1367 6.86296 19 7.9278 19H16.7951C17.8596 19 18.7229 18.137 18.7229 17.0722C18.7229 16.7403 18.6388 16.4287 18.4915 16.1561ZM9.30067 13.7927L11.5902 10.1318V7.81904H13.1324V10.1318L15.4219 13.7927H9.30067Z",
    fill: "#39BB0B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDon);
export default __webpack_public_path__ + "static/media/don.80f8c0ae.svg";
export { ForwardRef as ReactComponent };